import { Component } from 'react'
import Octicon, { Package, Law } from '@primer/octicons-react'
import Measurements from '~/utils/Measurements'
import styles from '~/styles/ordersDetails.multipackage.module.css'

export default class Multipackage extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}

	public constructor(props) {
		super(props)
		this._setMap()
		this.measurements = new Measurements()
		this.measurements.init(this.props.order, this.props.authDealerId)
		this.state = {
			isTableShown: false,
		}
	}

	public render(): JSX.Element | null {
		if (this.props.order.multiPackages?.package_nums?.length > 1) {
			return this._getMulti()
		} else {
			return this._getSingle()
		}
	}

	private _setMap() {
		this.map = {
			tracking_numbers: {
				key: "delivery_tracking",
				urlKey: "tracking_url",
				defaultTitle: (<span className="font-bold pr-1">{this.props.t("Tracking")}:</span>),
				multiTitle: (<span className="font-bold pr-1">{this.props.t("Trackings")}:</span>),
			},
			dimensions: {
				defaultTitle: (
					<div className={styles.detailsIconFrame}>
                		<Octicon icon={Package} />
              		</div>
              	),
			},
			weights: {
				defaultTitle: (
					<div className={styles.detailsIconFrame}>
                		<Octicon icon={Law} />
              		</div>
              	),
			},
		}
	}

	private _getSingle(): JSX.Element {
		return (
			<>
				{this.map[this.props.type].defaultTitle}
				{this._getValue(true)}
			</>
		)	
	}

	private _getMulti(): JSX.Element {
		return (
			<table
				className={styles.table + (this.props.type === "tracking_number" ? " " + styles.onGrey : "")}
			>
				<body>
					{this._getMultiTrs()}
				</body>
			</table>
		)
	}

	private _getMultiTrs() {
		const jsx = []
		let isIconAdded = false
		if (this.props.type !== "tracking_numbers") {
			jsx.push((
				<tr
					key={"order"}
					className={styles.orderTr}
				>
					{this._getIconTd(true, true)}
					<td className={styles.packageNumber}>
						<span>order:</span>
					</td>
					<td>
						{this._getValue(true)}
					</td>
				</tr>
			))
			isIconAdded = true
		}
		const array = this.props.order.multiPackages[this.props.type]
		for (let i = 0; i < array?.length; i++) {
			const packageNumber = this.props.order.multiPackages.package_nums[i]
			jsx.push((
				<tr
					key={i}
				>
					{this._getIconTd(!i && !isIconAdded)}
					<td className={styles.packageNumber}>
						<span>pkg {packageNumber}:</span>
					</td>
					<td>
						{this._getValue(false, array[i])}
					</td>
				</tr>
			))
		}
		return jsx
	}

	private _getIconTd(show, isWholeOrderDataShown) {
		if (show) {
			let count = this.props.order.multiPackages.package_nums.length
			if (isWholeOrderDataShown) {
				count++
			}
			return (
				<td rowSpan={count}>
					{this.map[this.props.type].multiTitle || this.map[this.props.type].defaultTitle}
				</td>
			)
		} else {
			return null
		}
	}

	private _getValue(isSingle, data) {
		let value = data
		if (this.props.type === "tracking_numbers") {
			let url = this.props.order[this.map[this.props.type].urlKey]
			if (isSingle) {
				data = this.props.order[this.map[this.props.type].key]
			} else {
				url = this.props.order.tracking_url_template?.replace(/{{(\w+)}}/g, (all, key) => {
				    return data
				}) 
			} 
			if (url) {
				value = (
					<a href={url} target="_blank">
						{data}
					</a>
				)
			}
		} else if (this.props.type === "dimensions") {
			value = this._getDimensions(isSingle, data)
		} else if (this.props.type === "weights") {
			value = this._getWeight(isSingle ? this.props.order?.mu_in_weight : data)
		}
		return value
	}

	private _getDimensions(isSingle, data) {
		let dimensions = ''
		let displayMu = 'in'
		const fromMu = this.props.order?.order_dimensions_mu
		const rawLength = (isSingle ? this.props.order?.mu_in_length : data?.[0])
		let length = this.measurements.muToMu(rawLength, fromMu) || 0
		const rawWeight = (isSingle ? this.props.order?.mu_in_width : data?.[1])
		let width = this.measurements.muToMu(rawWeight, fromMu) || 0
		const rawHeight = (isSingle ? this.props.order?.mu_in_height : data?.[2])
		let height = this.measurements.muToMu(rawHeight, fromMu) || 0
		if (this.measurements.dimensionalMu === 'cm') {
		    displayMu = 'mm'
		    length = Math.round(length * 10)
		    width = Math.round(width * 10)
		    height = Math.round(height * 10)
		} else {
		    length = Math.round(length * 10) / 10
		    width = Math.round(width * 10) / 10
		    height = Math.round(height * 10) / 10
		}
	  	dimensions += length + this.props.t(displayMu) + ' x '
	  	dimensions += width + this.props.t(displayMu) + ' x '
	  	dimensions += height + this.props.t(displayMu)
	  	return dimensions
	}

	private _getWeight(muWeight) {
		const fromMu = this.props.order?.order_weight_mu
		const weight = this.measurements.muToMu(muWeight, fromMu, true) || 0
	  	const weightString = this.measurements.muToString(weight, this.props.t, true, fromMu)
	  	return weightString
	}
}